import logger from './logger';

import api from './api';
import authHeader from './auth-header';
// Dans le fichier où vous avez besoin de l'adresse IP
import config from './config';
import AuthService from './auth.service';
const userId = AuthService.getUserId();

const API_URL = `${config.serverIP}/${config.apiVersion}/profils`;


class EventService{


  getEventByUser(){
    
    let url=`${API_URL}/users/${userId}/events`;

    //const headers=authHeader();
    logger.log('call event');
    //api.get(url, { headers, params: req })
    //return api.get(url,{ headers, pareq });
    // Effectuer la requête GET avec Axios
    return api.get(url, { headers: authHeader() })
  }

    getEventByAppliance(applianceId){
        
        let url=`${API_URL}/users/${userId}/appliances/${applianceId}/events`;

        //const headers=authHeader();
        logger.log('call event', url);
        //api.get(url, { headers, params: req })
        //return api.get(url,{ headers, pareq });
        // Effectuer la requête GET avec Axios
        return api.get(url, { headers: authHeader() })
    }


    saveEvent(deviceId, maintenanceCardId, title,note, type,status,date_realisation) {
        const currentDate = new Date();
        if (!(date_realisation)) date_realisation=currentDate;
        const req = {
          "applianceId":deviceId,
          "maintenanceCardId":maintenanceCardId,
          "title":title,
          "dt_creation":currentDate,
          "dt_realisation":date_realisation, 
          "note":note,
          "type":type,
          "status":status
        }

        logger.log('saveEvent sent ',req);
        
        let url=`${API_URL}/users/${userId}/events`;
        return api.post(url,req,{ headers: authHeader() });
    }

    saveEventNote = async (eventId, note) => {
      try {
        const url = `${API_URL}/users/${userId}/events/${eventId}`;
        const response = await api.put(url, { note },{ headers: authHeader() });
    
        if (response.status === 200) {
          logger.log("Event updated successfully:", response.data);
          return response.data; // Retourne l'événement mis à jour
        } else {
          logger.log("Failed to update the event.");
          return null;
        }
      } catch (error) {
        logger.log("Error occurred while saving event note:", error);
        throw error; // Propagation de l'erreur pour un éventuel traitement supérieur
      }
    };

    //-1 for null value
    saveMaintenanceEvent(dt_creation,dt_planned,title, note, applianceId,maintenanceCardId) {
      
      let url=`${API_URL}/users/${userId}/events`;

      const req = {
        "title":title,
        "dt_creation":dt_creation,
        "dt_realisation":dt_planned,
        "frequency":"",
        "note":note,
        "type":"MAINTENANCE",
        "status":"NEW",
        "applianceId":applianceId,
        "maintenanceCardId":maintenanceCardId
      }

      logger.log('saveevent sent ',req);
    
      return api.post(url,req,{ headers: authHeader() });
    }

    //-1 for null value
    saveMaintenancePeriodPlanning(dt_creation,frequency,title, note, applianceId,maintenanceCardId) {
      let url=`${API_URL}/users/${userId}/events/period`;

       
      const req = {
        "title":title,
        "dt_creation":dt_creation,
        "dt_realisation":"",
        "frequency":frequency,
        "note":note,
        "type":"MAINTENANCE",
        "status":"NEW",
        "applianceId":applianceId,
        "maintenanceCardId":maintenanceCardId
      }

      logger.log('saveevent sent ',req);
    
      return api.post(url,req,{ headers: authHeader() });
    }
    
}


// Créez une instance de NotifService
const EventServiceInstance = new EventService();

// Exportez l'instance en tant qu'export par défaut
export default EventServiceInstance;


//export default new EventService();